import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ApiBaseUrl } from "../../../Config";
import { Link } from "react-router-dom";

export default function MapTable() {
  const [loading, setLoading] = useState(false);
  const [Data, setData] = useState([]);
  const [location_code, setLocation_code] = useState(null);
  const [filter, setFilter] = useState(null);
  var index = 0;
  const GetData = async () => {
    setLoading(true);
    let url = `${ApiBaseUrl}/import/map/data?name=Import`;
    if (location_code) url += `&new_location_code=${location_code}`;
    try {
      const response = await axios.get(url);
      if (response?.data?.data) {
        setData(response.data.data);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error Fetching Data: ${error.message}`,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="d-flex align-items-center justify-content-center py-3 px-2 ">
        <div className="col">
          <Link
            to="/import"
            className="btn btn-label-primary waves-effect waves-light me-3"
          >
            <i className="ri-arrow-left-line ri-20px" />
          </Link>
          <Link to="/import/map" className="btn btn-outline-primary me-1">
            Grid
          </Link>
          <Link to="/import/map/table" className="btn btn-primary me-1">
            Table
          </Link>
        </div>
        <div className="col">
          <h6 className="text-center">Import Warehouse</h6>
        </div>
        <div className="col"></div>
      </div>
      <div className="container">
        <hr />
        <div className="row align-items-center">
          <div className="col-md-3">
            <div className="form-floating form-floating-outline">
              <input
                type="text"
                id="location_code"
                name="location_code"
                className="form-control"
                placeholder="Location Code"
                value={location_code}
                onChange={(e) => setLocation_code(e.target.value.toUpperCase())}
              />
              <label htmlFor="location_code">Location Code</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline">
              <select
                name="filter"
                id="filter"
                className="form-select"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option>All</option>
                <option>Occupied</option>
                <option>Spillover</option>
                <option>Holdcargo</option>
                <option>Available</option>
              </select>
              <label htmlFor="location_code">Sort By Area</label>
            </div>
          </div>
          <div className="col-md-3">
            <button className="btn btn-info" onClick={GetData}>
              Submit
            </button>
          </div>
        </div>

        <div className="card mt-5">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-sm text-center">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Location Code</th>
                    <th>Total Area</th>
                    <th>Occupied</th>
                    <th>Spillover</th>
                    <th>Hold Cargo</th>
                    <th>Available</th>
                  </tr>
                </thead>
                <tbody>
                  {Data.length > 0 ? (
                    Data.map((item) => {
                      if (item.new_location_code != "CAMERA NOT INSTALL") {
                        let totalSpillOverSum = 0;
                        let totalOccupiedSum = 0;
                        let totalHoldSum = 0;

                        let ocrOccupied = {};
                        if (
                          item?.ocr_grid_wise_occupied &&
                          item?.ocr_occupied_area > 0
                        ) {
                          try {
                            ocrOccupied =
                              JSON.parse(item?.ocr_grid_wise_occupied) ?? {};
                          } catch (e) {
                            ocrOccupied = {};
                          }
                        }

                        let gridAllocation = [];
                        if (
                          item?.ocr_occupied_area > 0 &&
                          item?.occupied_area > 0 &&
                          (item?.carting_data?.length > 0 ||
                            item?.destuffing_data?.length > 0)
                        ) {
                          try {
                            const parsed =
                              JSON.parse(item?.grid_allocation) ?? {};
                            for (const [_, value] of Object.entries(parsed)) {
                              if (!value) continue;

                              let values = [];
                              try {
                                values = Array.isArray(value)
                                  ? value
                                  : JSON.parse(value);
                              } catch {
                                continue;
                              }

                              if (Array.isArray(values)) {
                                gridAllocation.push(...values);
                              }
                            }
                          } catch {}
                        }

                        const occupiedData = ocrOccupied?.data ?? {};
                        for (const [key, value] of Object.entries(
                          occupiedData
                        )) {
                          const index = Number(key);
                          if (value === "F") {
                            if (!gridAllocation.includes(index + 1)) {
                              totalSpillOverSum += 1;
                            }
                          }
                        }

                        for (const block of gridAllocation) {
                          totalOccupiedSum += 1;
                        }

                        for (let i = 0; i < item?.hold_cargo_area; i++) {
                          totalHoldSum += 1;
                        }

                        totalOccupiedSum = Math.max(
                          0,
                          Math.min(20, Math.floor(totalOccupiedSum - totalHoldSum))
                        );                        

                        let available = Math.max(
                          0,
                          Math.min(20,
                          Math.floor(
                            item.total_area -
                              totalOccupiedSum -
                              totalSpillOverSum -
                              totalHoldSum
                          ))
                        );

                        if (
                          !filter ||
                          (filter == "Occupied" && totalOccupiedSum > 0) ||
                          (filter == "Spillover" && totalSpillOverSum > 0) ||
                          (filter == "Holdcargo" && totalHoldSum > 0) ||
                          (filter == "Available" && available > 0)
                        ) {
                          index++;
                          return (
                            <tr key={index}>
                              <td>{index}</td>
                              <td>{item.new_location_code}</td>
                              <td>{item.total_area}</td>
                              <td>{totalOccupiedSum ?? 0}</td>
                              <td>{totalSpillOverSum ?? 0}</td>
                              <td>{totalHoldSum ?? 0}</td>
                              <td>{available ?? 0}</td>
                            </tr>
                          );
                        }
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
